import { render, staticRenderFns } from "./HotpointPicText.vue?vue&type=template&id=9173b22c&scoped=true"
import script from "./HotpointPicText.vue?vue&type=script&lang=js"
export * from "./HotpointPicText.vue?vue&type=script&lang=js"
import style0 from "./HotpointPicText.vue?vue&type=style&index=0&id=9173b22c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9173b22c",
  null
  
)

export default component.exports